import React from 'react';
import './StatusBadge.css';

export default function StatusBadge({ variant = 'secondary', children }) {
  return <span className={`table-status-badge is-${variant}`}>{children}</span>;
}
